import { useHistory } from 'react-router-dom';
import { Button, IconButton } from '@material-ui/core';
import { ChevronLeft, Link } from '@carbon/icons-react';
import styled from 'styled-components';
import { clsx, colorSet, useSnackbar } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { useSelector } from '@store';
import AppConfig from '@config';
import useStyles from '../useStyles';

interface Props {
  label?: string;
  gutterBottom?: boolean;
  onPrevious: () => void;
}

const RightSideHeader = ({
  label,
  gutterBottom = false,
  onPrevious
}: Props) => {
  const { location } = useHistory();
  const rfqId = useSelector(
    (store) =>
      store?.dashboard?.selectedQuotationId?.rfqId ??
      location?.pathname.split('/')[2] ??
      ''
  );
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const onClickCopyLink = async () => {
    if (!rfqId) {
      return enqueueSnackbar('견적요청서 id를 찾을 수 없습니다.');
    }

    try {
      await navigator?.clipboard?.writeText?.(
        `${AppConfig.partnersUrl}/request/${rfqId}?shared=true`
      );

      enqueueSnackbar('해당 견적요청서의 링크를 복사했습니다.');
    } catch {
      enqueueSnackbar('클립보드 복사를 지원하지 않는 브라우저입니다.');
    }
  };

  return (
    <>
      <div className={classes['Dashboard-Right-Detail-Header']}>
        <div className="close" onClick={onPrevious}>
          <IconButton size="small" className="goback">
            <ChevronLeft />
          </IconButton>
        </div>
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          fontWeight="500"
        >
          {label}
        </CustomizedTypography>
        <LinkCopyButton
          startIcon={<Link size={20} color={colorSet.gray900} />}
          onClick={onClickCopyLink}
        >
          <CustomizedTypography variant="body1" fontWeight="500">
            링크복사
          </CustomizedTypography>
        </LinkCopyButton>
      </div>

      <div
        className={clsx(classes['Dashboard-Right-Detail-Header'], {
          block: true,
          guttuerBottom: gutterBottom
        })}
      />
    </>
  );
};

export default RightSideHeader;

const LinkCopyButton = styled(Button)`
  .MuiButton-startIcon {
    margin-right: 4px;
  }
`;
